import React, { useCallback } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useTasks } from "src/context/tasks";
import { useScrollToTop } from "src/hooks/useScrollToTop";
import Tasks from "./Tasks";
import TaskScheduling from "./TaskScheduling";
import TaskContactInfo from "./TaskContactInfo";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""
);

const taskPages = {
  1: Tasks,
  2: TaskScheduling,
  3: TaskContactInfo,
};

interface TasksFlowProps {}

export default function TasksFlow(props: TasksFlowProps) {
  const { taskPage, setTaskPage } = useTasks();

  useScrollToTop(taskPage);

  const changeTaskPage = useCallback(
    (page: number) => {
      setTaskPage(page);
    },
    [setTaskPage]
  );

  const Component = taskPages[taskPage] || Tasks;

  // Wrap contact/payment page (step 3) with Stripe Elements
  if (taskPage === 3) {
    return (
      <Elements
        stripe={stripePromise}
        options={{
          appearance: {
            theme: "stripe",
          },
        }}
      >
        <Component changeTaskPage={changeTaskPage} />
      </Elements>
    );
  }

  return <Component changeTaskPage={changeTaskPage} />;
}
